import { render, staticRenderFns } from "./layout-product-promos.vue?vue&type=template&id=2a1b25c8&scoped=true&"
import script from "./layout-product-promos.vue?vue&type=script&lang=js&"
export * from "./layout-product-promos.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-promos.vue?vue&type=style&index=0&id=2a1b25c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b25c8",
  null
  
)

export default component.exports